<template lang="jade">
  input(
    type="hidden"
    ":name"="inputName"
    v-for="input in inputValue"
    ":value"="inputValue"
  )
</template>

<script>
  export default {
    props: ['fdata'],
    computed: {
      editable () {
        return (this.fdata.editable === false)
      },
      inputValue () {
        return [].concat(this.fdata.value)
      },
      inputName () {
        if (this.fdata.editable === true) {
          if (this.inputValue.length > 1) {
            let multifield = this.fdata.field + '[]'
            return multifield
          } else {
            return this.fdata.field
          }
        }
        return false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// hidden.vue?7c136b74